/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_CreatorInputs */

const en_badge_creator = /** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator`)
};

const id_badge_creator = /** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreator`)
};

/** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */
const es_badge_creator = en_badge_creator;

/** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */
const fr_badge_creator = en_badge_creator;

/** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */
const de_badge_creator = en_badge_creator;

/** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */
const ja_badge_creator = en_badge_creator;

/** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */
const zh_badge_creator = en_badge_creator;

/** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */
const ar_badge_creator = en_badge_creator;

/** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */
const it_badge_creator = en_badge_creator;

/** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */
const ru_badge_creator = en_badge_creator;

/** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */
const pt_badge_creator = en_badge_creator;

/** @type {(inputs: Badge_CreatorInputs) => LocalizedString} */
const ko_badge_creator = en_badge_creator;

/**
* | output |
* | --- |
* | "Creator" |
*
* @param {Badge_CreatorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const badge_creator = /** @type {((inputs?: Badge_CreatorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_CreatorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_badge_creator(inputs)
	if (locale === "es") return es_badge_creator(inputs)
	if (locale === "fr") return fr_badge_creator(inputs)
	if (locale === "de") return de_badge_creator(inputs)
	if (locale === "ja") return ja_badge_creator(inputs)
	if (locale === "zh") return zh_badge_creator(inputs)
	if (locale === "ar") return ar_badge_creator(inputs)
	if (locale === "id") return id_badge_creator(inputs)
	if (locale === "it") return it_badge_creator(inputs)
	if (locale === "ru") return ru_badge_creator(inputs)
	if (locale === "pt") return pt_badge_creator(inputs)
	return ko_badge_creator(inputs)
});